export const LOCAL_CHANNEL_NAME = "citydna-app-preview";
export const PRESENCE_CHANNEL_PREFIX = "presence-";
